import request from "@utils/request";

/**
 * @author FJJ
 * @version 1.0
 * @Time 2021.12.30
 *
 * RAP
 * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=236#6674
 **/
const LogisticsAction = {

    /**
     * 新增/编辑公司信息
     * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=211#7868
     * @param data
     */
    addOrUpdate(data={}) {
        return request({
            url: '/service/mg/whs/logistics/company/addOrUpdate',
            method: "POST",
            data
        });
    },
    /**
     * 物流公司详情
     * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=211#7869
     * @param data
     */
    getDetail(data={}) {
        return request({
            url: '/service/mg/whs/logistics/company/detail',
            method: "POST",
            data
        });
    },
    /**
     * 删除物流公司
     * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=211#7870
     * @param data
     */
    delete(data={}) {
        return request({
            url: '/service/mg/whs/logistics/company/delete',
            method: "POST",
            data
        });
    },
};

export default LogisticsAction;
